export default "__VITE_ASSET__BJ$foJvN__"